// @ts-nocheck
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import { getAggregatedStats, getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getCampaigns } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { SummaryProvider } from '@/ts-contexts/reporting/Summary/SummaryProvider';
import { Header } from '@/ts-modules/reporting/Header';
import { ReportingStyle } from '@/ts-modules/reporting/Reporting/reporting.styled';
import { SubHeader } from '@/ts-modules/reporting/SubHeader';
import ReportingContent from './ReportingContent';
import { useReporting } from './ReportingContext';

import type { CampaignItem } from '../Header/Campaigns/Multi/components/EditSelectionModal/EditSelectionModal';

export function ReportingWrapper() {
  const {
    reporting: { cartography, currentCurrency, user, userRoles }
  } = useReporting();
  const reportingCampaigns: CampaignItem[] = useSelector(getSelectedCampaigns);
  const selectedReportingCampaignsIds = useSelector(getCampaigns);
  const selectedCampaigns = reportingCampaigns.filter(({ id }) => selectedReportingCampaignsIds.includes(id));
  const stats = useSelector(getAggregatedStats);
  const showGTotal =
    user.billing.method !== 'prepaid' && checkUserResourcePermissions('reportingGTotal', user, userRoles);

  const isReportingReady = selectedCampaigns.length > 0 && userRoles.length > 0 && cartography.length > 0;
  if (!isReportingReady) {
    return null;
  }

  return (
    <SummaryProvider campaigns={selectedCampaigns} currency={currentCurrency} user={user} userRoles={userRoles}>
      <ReportingStyle className="reporting">
        <Header
          campaigns={selectedCampaigns}
          cartography={[]} // todo
          id="reporting-header"
          noStats={isEmpty(stats)}
          showGTotal={showGTotal}
          stats={stats}
          titleNav="reporting.header.title"
          user={user}
          userRoles={userRoles}
        />
        <div id="sonata-reporting">
          <SubHeader campaigns={selectedCampaigns} user={user} userRoles={userRoles} />
          <ReportingContent />
        </div>
      </ReportingStyle>
    </SummaryProvider>
  );
}
